//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import { ContentLibrarySourcesGroups } from '@apis/content-library/contentLibraryApiModel';
import { NestedCheckboxGroup } from '@media-library/components/top-bar/DropdownNestedCheckbox';
import { MediaLibrarySourcesDropdownItem } from '@media-library/components/top-bar/sources-dropdown/MediaLibrarySourcesDropdownItem';
import { ViewAllButton } from '@media-library/components/top-bar/sources-dropdown/ViewAllButton';
import {
  MaxDisplayItems,
  MediaLibrarySourcesDropdownItemData,
} from '@media-library/components/top-bar/sources-dropdown/mediaLibrarySourcesDropdownConstants';
import { filterSources } from '@media-library/components/top-bar/sources-dropdown/mediaLibrarySourcesDropdownUtils';

interface MediaLibrarySourcesDropdownGroupProps {
  handleChangeSelect: (item: MediaLibrarySourcesDropdownItemData) => void;
  handleOpenModal: (sourcesGroup: ContentLibrarySourcesGroups) => void;
  searchTerm?: string;
  source: MediaLibrarySourcesDropdownItemData;
}

export const MediaLibrarySourcesDropdownGroup = ({
  handleChangeSelect,
  handleOpenModal,
  searchTerm = '',
  source,
}: MediaLibrarySourcesDropdownGroupProps) => {
  const { paramKey, subItems = [], value } = source;

  const filteredSubItems = subItems.filter((source) =>
    filterSources(source, searchTerm),
  );

  if (filteredSubItems.length === 0) return <></>;

  const maxDisplayItems =
    paramKey === 'sourcesGroups' ? MaxDisplayItems[value] : Infinity;

  const shouldShowViewAllButton = filteredSubItems.length > maxDisplayItems;

  return (
    <NestedCheckboxGroup
      endComponent={
        paramKey === 'sourcesGroups' && shouldShowViewAllButton ? (
          <ViewAllButton onClick={() => handleOpenModal(value)} />
        ) : undefined
      }
    >
      {filteredSubItems.slice(0, maxDisplayItems).map((subItem) => (
        <MediaLibrarySourcesDropdownItem
          handleChangeSelect={handleChangeSelect}
          handleOpenModal={handleOpenModal}
          key={subItem.value.toString()}
          searchTerm={searchTerm}
          source={subItem}
        />
      ))}
    </NestedCheckboxGroup>
  );
};
